import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: {
        year: "",
        month: [],
        customer_type: "",
        region: "",
        departure_port_uid: [],
        duration: "",
        things_to_look_in_great_holiday: "",
    },
    results: [],
    selections: "",
    finish: false,
    valid: false,
    status: "idle",
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const incrementAsync = createAsyncThunk("focusItinerary/fetchCount", async (amount) => {
    // The value we return becomes the `fulfilled` action payload
});

export const focusItinerarySlice = createSlice({
    name: "focusItinerary",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        addToFocusItinerary: (state, action) => {
            state.value = action.payload;
        },
        addToFocusItineraryValid: (state, action) => {
            state.valid = action.payload;
        },
        addToFocusItineraryResults: (state, action) => {
            state.results = action.payload;
        },
        addToFocusItinerarySelections: (state, action) => {
            state.selections = action.payload;
        },
        addToFocusItineraryFinish: (state, action) => {
            state.finish = action.payload;
        },
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {},
});

export const {
    addToFocusItinerary,
    addToFocusItineraryValid,
    addToFocusItineraryResults,
    addToFocusItinerarySelections,
    addToFocusItineraryFinish,
} = focusItinerarySlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.focusItinerary.value)`
export const selectFocusItinerary = (state) => state.focusItinerary;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
export const clearFocusItineraryValue = () => (dispatch, getState) => {
    dispatch(
        addToFocusItinerary({
            year: "",
            month: [],
            customer_type: "",
            region: "",
            departure_port_uid: [],
            duration: "",
            things_to_look_in_great_holiday: "",
        })
    );
};

export default focusItinerarySlice.reducer;
